<div class="confirm-modal-popup">
    <span class="material-icons close-icon-modal position-absolute" (click)="close()">close</span>
    <img src="assets/images/confirm-delete-clear.svg" alt="confirm-delete-clear" class="modal-icon">
    <div class="modal-message">
        <p class="f-16 pb-0 mb-0">The offer for LYNK ID# <span class="green_text">{{data}}</span> has been declined.</p>
    </div>
    <div class="modal-actions">
        <button mat-button class="btn rounded_btn green_btn small_btn px-4 fw-400" (click)="close()"> OK</button>
    </div>
</div>